import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NotificationApp } from "./NotificationApp";
import { useLocation, useNavigate } from "react-router-dom";
import { startGetHasPendingSurveys } from "../redux/slices/users/Surveys";
import Swal from "sweetalert2";

const swalAlert = () =>
    Swal.fire({
        title: "<strong>Encuestas pendientes</strong>",
        html: `
            <p><strong>Aún no has completado tus encuestas obligatorias.</strong></p>
            <p>Por favor, respóndelas para poder acceder a los demás apartados.</p>
        `,
        icon: "info",
        confirmButtonText: "Entendido",
        backdrop: true,
        padding: "2em",
    });

export const PendingSurveys = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const { session, user } = useSelector((state) => state.auth);
    const { hasPendingSurveys } = useSelector((state) => state.surveys);

    useEffect(() => {
        if (["student", "teacher"].includes(session)) {
            dispatch(startGetHasPendingSurveys());
        }
    }, [user]);

    useEffect(() => {
        const pathname = location.pathname;
        const isInSurveysModule = pathname.startsWith("/my/surveys");

        //* Si el usuario es normal, tiene encuestas pendientes y no esta en el modulo de encuestas, redireccionar
        if (hasPendingSurveys && !isInSurveysModule) {
            switch (session) {
                case "student":
                    if (user.status === "NORMAL") {
                        swalAlert();
                        navigate("/my/surveys");
                    }
                    break;
                case "teacher":
                    swalAlert();
                    navigate("/my/surveys");
                    break;
            }
        }
    }, [location, hasPendingSurveys]);

    return <></>;
};
